// 創建音效工具類
const SoundUtils = {
    buttonClick: new Audio('../assets/sounds/button-click.mp3'),
    optionSelect: new Audio('../assets/sounds/option-select.mp3'),
    transition: new Audio('../assets/sounds/transition.mp3'),
    explosion: new Audio('../assets/sounds/explosion.mp3'),
    result: new Audio('../assets/sounds/result.mp3'),
  
    // 初始化音效（預加載）
    init() {
      // 強制預加載所有音效
      this.buttonClick.load();
      this.optionSelect.load();
      this.transition.load();
      this.explosion.load();
      this.result.load();
      
      // 設置音量
      this.buttonClick.volume = 0.3;
      this.optionSelect.volume = 0.3;
      this.transition.volume = 0.4;
      this.explosion.volume = 0.5;
      this.result.volume = 0.4;
    },
  
    // 播放按鈕點擊音效
    playButtonClick() {
      this.buttonClick.currentTime = 0;
      this.buttonClick.play().catch(e => console.log("音效播放失敗:", e));
    },
  
    // 播放選項選擇音效
    playOptionSelect() {
      this.optionSelect.currentTime = 0;
      this.optionSelect.play().catch(e => console.log("音效播放失敗:", e));
    },
  
    // 播放轉場音效
    playTransition() {
      this.transition.currentTime = 0;
      this.transition.play().catch(e => console.log("音效播放失敗:", e));
    },
  
    // 播放爆炸音效
    playExplosion() {
      this.explosion.currentTime = 0;
      this.explosion.play().catch(e => console.log("音效播放失敗:", e));
    },
  
    // 播放結果音效
    playResult() {
      this.result.currentTime = 0;
      this.result.play().catch(e => console.log("音效播放失敗:", e));
    }
  };
  
  export default SoundUtils;